import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Config from "config";
//Import Images
import error from "../../assets/images/error-img.png";

const Pages403 = () => {
  const backUrl = Config.backOffice.url;
  //meta title
  document.title = "403 Error Page | DOM COM";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">
                <h4 className="text-uppercase">
                  {" "}
                  Vous n'avez pas le droit d'accéder à cette page
                </h4>
                <div className="mt-5 text-center">
                  <Link
                    className="btn btn-primary waves-effect waves-light "
                    to={`${backUrl}/fdashboards`}
                  >
                    Retour au dashboard
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" xl="6">
              <div>
                <img src={error} alt="" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Pages403;
